<template>
  <div id="noticiasPagination" v-if="listLength > 0">
    <div class="row">
      <div class="small-12 medium-12 large-12 columns numeros_pag_noticia">
        <div class="numeros_noticias">
          <p class="numero_paginas_noticias"
             :key="page.id"
             :class="{active: page.id == currentPage}"
             v-for="page in pages"
             @click="setPage(page.id)">
              {{page.page}}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-center loadmorewrapper" v-if="listLength < totalElements">
    <div class="small-12 medium-7 columns">
      <SaberBotao2
          class="btnvermais"
          :background-color="this.color"
          :border-color="this.color"
          :text-color="this.color"
          @click="loadMore">
        {{ $translate("UMA_LANG_DEPARTAMENTOS_VERMAIS") }}
      </SaberBotao2>
    </div>
  </div>
</template>

<script>
import SaberBotao2 from '@/components/botao2.vue';

export default {
  name: "paginationDep",
  props:['totalElements','listLength','limit',"currentPage","color"],
  inject:[],
  emits:["load-more","change-page"],
  components:{
    SaberBotao2
  },
  data(){
    return {
      pages:[{id:1,page:"1"},{id:2,page:"2"}],
    }
  },
  beforeUpdate() {
    this.generatePages();
  },
  methods:{
    loadMore(){
      this.$emit("load-more");
    },
    setPage(page){
      this.$emit("change-page",page);
    },
    generatePagesObject(total){
      return [...Array(total).keys()].map(el => {
        return {
          id: el+1,
          page: `${el+1}`
        }
      });
    },
    generatePages() {
      const total = Math.ceil(this.totalElements/this.limit);
      if(total < 8){
        this.pages = this.generatePagesObject(total);
      }else{
        if(this.currentPage < 5){
          const updatedPages = this.generatePagesObject(5);
          const intermediumpage = {
            id: updatedPages.length+1,
            page: `...`
          }
          this.pages = [...updatedPages,intermediumpage,{id:total,page:`${total}`}]
        }else if(this.currentPage < total - 3 ) {
          this.pages = [
            {id:1,page:"1"},
            {id:2,page:"..."},
            {id:this.currentPage-1,page:this.currentPage-1},
            {id:this.currentPage,page:this.currentPage},
            {id:this.currentPage+1,page:this.currentPage+1},
            {id:6,page:"..."},
            {id:total,page:`${total}`},
          ]
        }else{
          this.pages = [
            {id:1,page:"1"},
            {id:2,page:"..."},
            {id:total-4,page:`${total-4}`},
            {id:total-3,page:`${total-3}`},
            {id:total-2,page:`${total-2}`},
            {id:total-1,page:`${total-1}`},
            {id:total,page:`${total}`},
          ];
        }
      }
    }
  }
}
</script>

<style scoped>
.loadmorewrapper{
  display: none;
}

#noticiasPagination{
  margin-top: 40px;
}

.numeros_pag_noticia {
  display: inline-flex;
  margin-top: 0px;
  margin-bottom: 80px;
}

.numeros_noticias {
  display: flex;
  margin: 0 auto;
}

.numero_paginas_noticias {
  background: transparent;
  color: #666;
  font-family: "Montserrat Bold";
  padding: 10px 20px 10px 18px;
  margin-right: 5px;
  margin-left: 5px;
  margin-bottom: 0;
  letter-spacing: 0.6px;
  border-bottom: 3px solid transparent;
  transition: border .2s ease-out;
}

.numero_paginas_noticias:hover {
  color: #404040;
  cursor: pointer;
  transition: border .2s ease-out;
  border-bottom: 3px solid v-bind("color");
}

.numero_paginas_noticias.ellipsis:hover{
  color: #404040;
  cursor: default;
  transition: border .0s ease-out;
  border-bottom: 3px solid transparent;
}

.numero_paginas_noticias.active{
  border-bottom: 3px solid v-bind("color");
  color: #404040;
  font-family: "Montserrat Bold";
  padding: 10px 20px 10px 18px;
  margin-right: 5px;
  margin-left: 5px;
  letter-spacing: 0.6px;
}

.numeros_pag_noticia {
  margin-bottom: 0px;
}

@media (max-width: 767px){
  .numeros_pag_noticia {
    display: none;
  }

  .loadmorewrapper {
    display: flex;
    flex: 1;
  }

  .loadmore, .loadmore:hover {
    font-family: 'Montserrat Bold';
    letter-spacing: 1.2px;
    background-color: transparent;
    color: #6eb7ec;
    border-color: #6eb7ec;
    border: 1px solid;
    margin: 0 auto;
    text-align: center;
    text-transform: uppercase;
    justify-content: center;
    display: flex;
    padding: 11px;
    font-size: 12px;
    margin-top: 39px;
  }

  .loadmorewrapper a {
    font-size: 12px;
  }

  #noticiasPagination {
    margin-top: -20px;
  }

  .loadmorewrapper {
    padding-right: 10px;
    padding-left: 10px;

  }
  






}









</style>